import organizationReducer from "./reducers";

export default organizationReducer;